import 'js-breakpoints'
import debounce from 'lodash.debounce'

let isSecondLevelOpen = false
let haveEventListenersBeenSetUp = false


function setMobileNavigationHeight() {
    const innerHeight = window.innerHeight
    document.querySelector('.c-navigation').style.height = innerHeight + 'px'
}

function toggleSecondLevelMenu(menuDropdown, primaryTrigger, secondaryTrigger) {
    return function() {
        const menuSecondLevel = menuDropdown
        isSecondLevelOpen = !isSecondLevelOpen
        menuSecondLevel.classList.add('c-navigation__mega--animate')
        menuSecondLevel.classList.toggle('c-navigation__mega--mobile-active')
        if(isSecondLevelOpen) {
            primaryTrigger.setAttribute('aria-expanded', true)
            secondaryTrigger.setAttribute('aria-expanded', true)
            setMobileNavigationHeight()
        }
        else {
            primaryTrigger.setAttribute('aria-expanded', false)
            secondaryTrigger.setAttribute('aria-expanded', false)
        }
    }

}
 
function setUpMobileMenu(list, toggle) {
    // guard - prevent multiple event listeners being setup when switching between breakpoints
    if(!haveEventListenersBeenSetUp && list) {
        haveEventListenersBeenSetUp = true
        setMobileNavigationHeight()
        window.addEventListener('resize', debounce(setMobileNavigationHeight, 100))
        list.forEach((item) => {
            const openSecondLevel = item.querySelector('.js-mobile-second-level-trigger-forward')
            const closeSecondLevel = item.querySelector('.js-mobile-second-level-trigger-back')
            const menuDropdown = item.querySelector('.js-drop-down')
            if(openSecondLevel && closeSecondLevel && menuDropdown) {
                openSecondLevel.addEventListener('click', toggle(menuDropdown, openSecondLevel, closeSecondLevel))
                closeSecondLevel.addEventListener('click', toggle(menuDropdown, closeSecondLevel, openSecondLevel))
            }
        })
    }
}

function mobileMenu(menuItem) {
    Breakpoints.on({
        name: 'bp-medium-max',
        matched: function() {
            setUpMobileMenu(menuItem, toggleSecondLevelMenu)
        },
        exit: function() {
            document.querySelector('.c-navigation').style.height = null
        }
    })
}

export default mobileMenu